<template>
  <div>
    <div v-if="isBatchManager === true">
      <BatchManager :key="componentKey"/>
    </div>
    <div v-else>
      <BatchClassic :key="componentKey"/>
    </div>
  </div>
</template>
<script>
import BatchClassic from './batchJob/BatchClassic'
import BatchManager from './batchJob/BatchManager'

export default {
  data() {
    return {
      componentKey: 0
    }
  },
  methods: {
    forceComponentReload() {
      this.componentKey++
    }
  },
  mounted() {
    this.forceComponentReload()
  },
  computed: {
    isBatchManager() {
      return this.$store.state.app.dataMap.isBatchManager
    }
  },
  components: {
    BatchClassic,
    BatchManager
  }
}
</script>

<style lang="scss"></style>
